import type { ModalProps } from '~/modal/modalType.enum';
import { DataLayerEditorModalComponent } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/modals/dataLayerEditorModal.component';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useGetBoundaryGroup } from '~/store/boundaryGroups/boundaryGroups.selectors';
import { usePremiumDemographicsList } from '~/store/demographics/premiumDemographics/usePremiumDemographicsList';
import type { DataLayerData } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const DataLayerEditorModalContainer = ({
  boundaryGroupId,
  ...restProps
}: ModalProps<{
  boundaryGroupId: BoundaryGroupId;
  initialData?: Partial<DataLayerData>;
  onSubmit: (dataLayerData: DataLayerData, alsoSaveTemplate?: boolean) => void;
}>) => {
  const { getBoundaryGroupById } = useGetBoundaryGroup();
  const { agsData, isLoading } = usePremiumDemographicsList();

  const boundaryGroup = getBoundaryGroupById(boundaryGroupId);
  const boundaryGroupName = boundaryGroup?.name ?? '';

  return (
    <DataLayerEditorModalComponent
      boundaryGroupName={boundaryGroupName}
      demographicsPerRegion={agsData}
      isLoading={isLoading}
      {...restProps}
    />
  );
};
